export default __webpack_public_path__ + "static/media/36I-102706_-15699_0.68e89a5d.jpg";